export default __webpack_public_path__ + "static/media/smartphoneswhite_2.0093dd4c.png";